export const OFFERING_TERMS_URL = "https://www.trimble.com/en/legal/offering-terms/terms/english";
